// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"baf98338","225":"54eec311","239":"10fa2eb3","277":"c8115579","453":"ca2bd2f5","455":"779cec06","522":"ec76a55b","626":"e6c8fedb","658":"23212312","977":"170bb81a"}[chunkId] + ".chunk.js";
};